
import React from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import { Button } from "@/components/ui/button";
import AdMaterialUrl from "./AdMaterialUrl";

// Schema específico para edición de material
const materialEditSchema = z.object({
  materialUrl: z.string().url("La URL debe ser válida para guardar.").or(z.string().length(0)).optional(),
});

interface AdMaterialEditFormProps {
  onSubmit: (data: { materialUrl: string }) => void;
  onCancel: () => void;
  initialMaterialUrl?: string;
}

const AdMaterialEditForm: React.FC<AdMaterialEditFormProps> = ({
  onSubmit,
  onCancel,
  initialMaterialUrl = ""
}) => {
  const form = useForm({
    resolver: zodResolver(materialEditSchema),
    defaultValues: {
      materialUrl: initialMaterialUrl
    },
    mode: "onChange" // Para feedback inmediato de validación
  });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    e.stopPropagation();
    
    const isValid = await form.trigger();
    if (isValid) {
      const formData = form.getValues();
      onSubmit({ materialUrl: formData.materialUrl || "" });
    } else {
      console.log("El formulario no es válido:", form.formState.errors);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div className="text-center mb-4">
        <h3 className="text-lg font-medium text-gray-900">
          Agregar Material del Anuncio
        </h3>
        <p className="text-sm text-gray-500 mt-1">
          Agrega o actualiza el enlace al material del anuncio
        </p>
      </div>

      <AdMaterialUrl form={form} isEdit={true} />

      <div className="flex justify-end gap-3 pt-4 border-t">
        <Button 
          type="button" 
          variant="outline" 
          onClick={onCancel}
        >
          Cancelar
        </Button>
        <Button 
          type="submit"
          className="bg-blue-600 hover:bg-blue-700"
        >
          Guardar Material
        </Button>
      </div>
    </form>
  );
};

export default AdMaterialEditForm;
